import React, { Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { BarcodeLoader } from './components/shared/ApeIcons';

const Home = React.lazy(() => import('./components/Home').then(m => ({ default: m.Home })));
const NewPairs = React.lazy(() => import('./components/NewPairs').then(m => ({ default: m.NewPairs })));
const ViewToken = React.lazy(() => import('./components/ViewToken').then(m => ({ default: m.ViewToken })));
const NewToken = React.lazy(() => import('./components/NewToken').then(m => ({ default: m.NewToken })));
const MyApes = React.lazy(() => import('./components/MyApes').then(m => ({ default: m.MyApes })));
const Profile = React.lazy(() => import('./components/Profile').then(m => ({ default: m.Profile })));
const Airdrop = React.lazy(() => import('./components/Airdrop').then(m => ({ default: m.Airdrop })));
const Docs = React.lazy(() => import('./components/Docs').then(m => ({ default: m.Docs })));
const Bridge = React.lazy(() => import('./components/Bridge').then(m => ({ default: m.Bridge })));
const Auth = React.lazy(() => import('./components/Auth').then(m => ({ default: m.Auth })));
const XToken = React.lazy(() => import('./components/XToken').then(m => ({ default: m.XToken })));

const PageLoader = () => (
	<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
		<BarcodeLoader />
	</div>
);

const Lazy = ({ children }) => (
	<Suspense fallback={<PageLoader />}>
		{children}
	</Suspense>
);

const AppRoutes = [
	{
		index: true,
		path: '/',
		element: <Lazy><Home /></Lazy>
	},
	{
		path: '/new-pairs',
		element: <Lazy><NewPairs /></Lazy>
	},
	{
		path: '/my-apes',
		element: <Lazy><MyApes /></Lazy>
	},
	{
		path: '/airdrop',
		element: <Navigate to="/" replace />
	},
	{
		path: '/docs',
		element: <Lazy><Docs /></Lazy>
	},
	{
		path: '/new-token',
		element: <Lazy><NewToken /></Lazy>
	},
	{
		path: '/profile',
		element: <Lazy><Profile /></Lazy>
	},
	{
		path: '/bridge',
		element: <Lazy><Bridge /></Lazy>
	},
	{
		path: '/einstein',
		element: <Lazy><Auth /></Lazy>
	},
	{
		path: '/x/:tweetId',
		element: <Lazy><XToken /></Lazy>
	},
	{
		path: '/:tokenChain/:tokenAddress',
		element: <Lazy><ViewToken /></Lazy>
	}
];

export default AppRoutes;
